module.exports = __webpack_public_path__ + "static/media/popup_1.786ce34f.png";